import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { BiFirstPage, BiLastPage } from "react-icons/bi";

export const Pagination = ({
  idComponente,
  totalRows,
  currentPage,
  setCurrentPage,
  rowPerPage,
  className,
}) => {
  const allPagines = Math.ceil(totalRows / rowPerPage);

  let nextPagines = [];
  let afterPagines = [];

  if (currentPage > 0) {
    for (let i = 1; i > 0; i--) {
      if (currentPage - i > 0) {
        afterPagines.push(currentPage - i);
      }
    }
  }
  if (currentPage <= allPagines) {
    for (let i = 0; i < 2; i++) {
      if (currentPage + i <= allPagines) {
        nextPagines.push(currentPage + i);
      }
    }
  }

  return (
    <>
      <div className={`container-grid_pagination ${className}`}>
        <div className="registers-of_total">
          <p>{`${
            rowPerPage * currentPage < totalRows
              ? rowPerPage * currentPage
              : totalRows
          } de ${totalRows}`}</p>
        </div>
        <div className="d-flex align-items-center ms-3 p-2">
          {currentPage >= 3 && (
            <span
              role={"button"}
              className={"d-flex"}
              onClick={() => setCurrentPage(1)}
            >
              <BiFirstPage color="#000" size={"20px"} />
            </span>
          )}

          {currentPage > 1 && (
            <span
              role={"button"}
              className={"d-flex"}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              <IoIosArrowBack color="#000" size={"15px"} />
            </span>
          )}

          {afterPagines.map((pagine) => {
            return (
              <div
                key={pagine}
                className="mx-2 font-main text-11px"
                role={"button"}
                onClick={() => setCurrentPage(pagine)}
              >
                <p className="number-paginate">{pagine}</p>
              </div>
            );
          })}
          {nextPagines.map((pagine) => {
            return (
              <div
                key={pagine}
                role={"button"}
                onClick={() => setCurrentPage(pagine)}
                className={`mx-2 text-11px ${
                  currentPage === pagine
                    ? "ball-pagination background-main font-main color-white d-flex justify-content-center align-items-center"
                    : ""
                }`}
              >
                <p className="number-paginate">{pagine}</p>
              </div>
            );
          })}
          {currentPage < allPagines && (
            <span
              role={"button"}
              className={"d-flex"}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              <IoIosArrowForward color="#000" size={"15px"} />
            </span>
          )}

          {currentPage < allPagines && (
            <span
              role={"button"}
              className={"d-flex"}
              onClick={() => setCurrentPage(allPagines)}
            >
              <BiLastPage color="#000" size={"20px"} />
            </span>
          )}
        </div>
      </div>
    </>
  );
};
